import { render, staticRenderFns } from "./ConfigPermisses.vue?vue&type=template&id=2315ec3a"
import script from "./ConfigPermisses.vue?vue&type=script&lang=js"
export * from "./ConfigPermisses.vue?vue&type=script&lang=js"
import style0 from "./ConfigPermisses.vue?vue&type=style&index=0&id=2315ec3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports